function init() {
	const inputs = document.querySelectorAll('.freeform-fieldtype-file input[type="file"]');
	if (!inputs.length) return;

	inputs.forEach(setupInput);
}

function setupInput(input) {
	const container = input.closest('.freeform-fieldtype-file');
	if (!container) return;

	// Native file inputs replace their FileList on each selection. Keep a
	// persistent DataTransfer so picking files in separate sessions accumulates
	// instead of discarding the previous selection.
	const store = new DataTransfer();

	const list = document.createElement('ul');
	list.className = 'freeform-file-list';
	container.appendChild(list);

	const isSameFile = (a, b) =>
		a.name === b.name && a.size === b.size && a.lastModified === b.lastModified;

	input.addEventListener('change', () => {
		Array.from(input.files).forEach(file => {
			const alreadyAdded = Array.from(store.files).some(existing => isSameFile(existing, file));
			if (!alreadyAdded) store.items.add(file);
		});

		input.files = store.files;
		renderList();
	});

	function removeAt(index) {
		const remaining = Array.from(store.files).filter((_, i) => i !== index);
		store.items.clear();
		remaining.forEach(file => store.items.add(file));

		input.files = store.files;
		renderList();
	}

	function renderList() {
		list.replaceChildren();

		Array.from(store.files).forEach((file, index) => {
			const item = document.createElement('li');
			item.className = 'freeform-file-item';

			const name = document.createElement('span');
			name.className = 'freeform-file-name';
			name.textContent = file.name;

			const remove = document.createElement('button');
			remove.type = 'button';
			remove.className = 'freeform-file-remove';
			remove.setAttribute('aria-label', `Remove ${file.name}`);
			remove.textContent = '✕';
			remove.addEventListener('click', () => removeAt(index));

			item.append(name, remove);
			list.appendChild(item);
		});
	}
}

document.addEventListener('DOMContentLoaded', init);
